import React from 'react';

const PlusCircle = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.925781" width="20" height="20" rx="10" fill="#F5F7FD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1347 10.3935H11.0318V7.2907C11.0318 7.14963 10.9758 7.01434 10.876 6.91458C10.7763 6.81483 10.641 6.75879 10.4999 6.75879C10.3588 6.75879 10.2236 6.81483 10.1238 6.91458C10.024 7.01434 9.968 7.14963 9.968 7.2907V10.3935H6.86517C6.72409 10.3935 6.5888 10.4496 6.48905 10.5493C6.38929 10.6491 6.33325 10.7844 6.33325 10.9255C6.33325 11.0665 6.38929 11.2018 6.48905 11.3016C6.5888 11.4013 6.72409 11.4574 6.86517 11.4574H9.968V14.5602C9.968 14.7013 10.024 14.8366 10.1238 14.9363C10.2236 15.0361 10.3588 15.0921 10.4999 15.0921C10.641 15.0921 10.7763 15.0361 10.876 14.9363C10.9758 14.8366 11.0318 14.7013 11.0318 14.5602V11.4574H14.1347C14.2757 11.4574 14.411 11.4013 14.5108 11.3016C14.6105 11.2018 14.6666 11.0665 14.6666 10.9255C14.6666 10.7844 14.6105 10.6491 14.5108 10.5493C14.411 10.4496 14.2757 10.3935 14.1347 10.3935Z"
        fill="#5C6983"
      />
    </svg>
  );
};

export default PlusCircle;
